import ArticleCard from "@components/Blocks/Card/Article/ArticleCard";
import { ProcessedArticleData } from "@transformer/useOSResponse";

export const ArticleCardWrapper = ({
  context,
}: {
  context: ProcessedArticleData;
}) => (
  <div className="basis-1/2 pb-2 lg:pb-4 border-b border-grey-850">
    <ArticleCard
      {...context}
      orientation="vertical-summary"
      variant="medium"
      displayWidth={454}
      displayHeight={303}
    />
  </div>
);
